import React from "react";

import { updateNotificationSettings } from "services";

import { getLocalKlimVar, useCancelAsyncOnUnmount } from "utils";

import { Col, Icon, Row, Switch, Message as message } from "components";

export const ProfileNotificationSetting = ({ details, hp, iconName, setLoading, setting, t, userId }) => {
  const signal = useCancelAsyncOnUnmount()();

  const changeNotificationSettings = (v) => {
    updateNotificationSettings({
      token: getLocalKlimVar("token") || userId,
      item: v,
      signal,
    })
      .then(() => {
        message({ content: t("notifications.updated"), icon: "tick" });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return setting === "newsletter" ? (
    <Row>
      <Col>
        <p className="list">
          <Icon iconName={iconName} size="m" className="icon inline" /> {t("notifications.newsletter.title")}
          <span>
            {t("notifications.newsletter.description")} <Switch defaultChecked={details.newsletter} onChange={() => changeNotificationSettings(setting)} />
          </span>
        </p>
      </Col>
    </Row>
  ) : (
    <Row>
      <Col>
        <p className="list">
          <Icon iconName={iconName} size="m" className="icon inline" /> {t(`notifications.titles.${setting}`)}
        </p>
        <p className="list">
          <span>
            {t(`notifications.emails.${setting}`)}{" "}
            <Switch defaultChecked={details[`${setting}_email`]} onChange={() => changeNotificationSettings(`${setting}_email`)} />
          </span>
        </p>
        {details.push && (
          <p className="list ">
            <span>
              {t(`notifications.push.${setting}${typeof hp === "boolean" ? (hp ? ".hp" : ".mp") : ""}`)}{" "}
              <Switch defaultChecked={details[`${setting}_push`]} onChange={() => changeNotificationSettings(`${setting}_push`)} />
            </span>
          </p>
        )}
      </Col>
    </Row>
  );
};
